var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lotteryCode !== '')?_c('div',[_c('iframe',{attrs:{"height":"568","width":"880","scrolling":"no","src":_vm.videoSrc,"frameborder":"0"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }